import FindDetailContainer from "./FindDetailContainer";

export default FindDetailContainer;
